import fetch from "auth/FetchInterceptor";

const AbsencesService = {};

const absencesEndpointPrefix = "/absenceManagement";

AbsencesService.getAbsences = async ({ type, page }) =>
    await fetch(
        type
            ? `${absencesEndpointPrefix}/getAll?absenceManagementType=${type}&page=${page}`
            : `${absencesEndpointPrefix}/getAll?page=${page}`,
        {
            method: "GET",
        }
    );

AbsencesService.getAbsenceById = async (id) =>
    await fetch(`${absencesEndpointPrefix}/getById/${id}`, {
        method: "GET",
    });

AbsencesService.createAbsence = async (data) =>
    await fetch(`${absencesEndpointPrefix}/create`, {
        data,
        method: "POST",
    });

AbsencesService.updateAbsence = async (id, data) =>
    await fetch(`${absencesEndpointPrefix}/update/${id}`, {
        data,
        method: "PUT",
    });

AbsencesService.deleteAbsenceById = async (id) =>
    await fetch(`${absencesEndpointPrefix}/deleteById/${id}`, {
        method: "DELETE",
    });

export default AbsencesService;
